// extracted by mini-css-extract-plugin
module.exports = {"menu-item-header":"menu-items-tree_menu-item-header__1yQ1S","menu-item-title":"menu-items-tree_menu-item-title__1bzaw","menu-name":"menu-items-tree_menu-name__369RE"};